module.exports = __webpack_public_path__ + "src/assets/games/10/335.jpg";